import Config from 'Config';

// redirect "/" to "/{BASENAME}/"
if (!window.location.pathname.includes(Config.BASENAME)) {
    window.history.replaceState(
      '',
      '',
      Config.BASENAME + window.location.pathname
    );
}